import { Button } from "../../../../shared/components/ui/Button";
import { FormField } from "../../../../shared/components/forms/FormField";
import { useAdminLoginForm } from "./useAdminLoginForm";
import type { AdminLoginFormProps } from "./AdminLoginForm.types";

export const AdminLoginForm: React.FC<AdminLoginFormProps> = ({
  onLogin,
  isSubmitting,
}) => {
  const { form, onSubmit } = useAdminLoginForm({ onLogin });
  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = form;

  return (
    <div className="flex flex-col gap-4 w-full max-w-sm">
      <h1 className="text-2xl font-bold">Administrador</h1>

      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-4">
        {/* Cédula */}
        <FormField
          type="input"
          label="Cédula de ciudadanía"
          required
          inputProps={{
            type: "text",
            placeholder: "Cédula de ciudadanía",
            ...register("citizenship_number"),
          }}
          error={errors.citizenship_number?.message}
        />

        {/* Contraseña */}
        <FormField
          type="input"
          label="Contraseña"
          required
          inputProps={{
            type: "password",
            placeholder: "Contraseña",
            ...register("password"),
          }}
          error={errors.password?.message}
        />

        {/* Submit */}
        <Button type="submit" disabled={!isValid || isSubmitting}>
          {isSubmitting ? "Iniciando sesión..." : "Iniciar sesión"}
        </Button>
      </form>
    </div>
  );
};
